import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.progress, action) => {
  switch (action.type) {
    case ActionTypes.PROGRESS_START:
      return {
        enable: true,
        message: action.message,
      };
    case ActionTypes.PROGRESS_STOP:
      return {
        enable: false,
        message: null,
      };
    default:
      return state;
  }
};
